module.exports = __webpack_public_path__ + "static/media/custom-checkbox-modern-1-checked.94f6922b.svg";